module.exports = __webpack_public_path__ + "img/shape_parallelogram_l.20f24406.svg";